import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRtdbValue } from "../firebase/listeners.js";
import { useAuthStore } from "../stores/auth.js";
import { useTableStore } from "../stores/table.js";

interface TableSummary {
  meta?: {
    name?: string;
    channelId?: string;
    gmUid?: string;
    members?: Record<string, unknown>;
  };
}

export default function Lobby() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const uid = useAuthStore((s) => s.uid);
  const { data: tables, loading } = useRtdbValue<Record<string, TableSummary>>("tables");
  const setTable = useTableStore((s) => s.setTable);

  useEffect(() => {
    if (loading || !tables || !uid) return;
    const entry = Object.entries(tables).find(([, tbl]) => {
      const members = tbl.meta?.members ?? {};
      return uid in members;
    });
    if (entry) {
      const [tableId, table] = entry;
      if (table.meta?.name && table.meta.gmUid) {
        setTable(tableId, { name: table.meta.name, gmUid: table.meta.gmUid });
        navigate("/table", { replace: true });
      }
    }
  }, [tables, loading, uid, navigate, setTable]);

  return <p className="p-4">{loading ? t("app.loading") : t("lobby.no-table")}</p>;
}
